import { useCallback, useEffect } from 'react'
import { batch, useSignal } from '@preact/signals-react'
import { formatDate, postSubmit } from '@ui-seeker/utils'

import { BACKEND_APIS } from '@constants'
import { companyUsers, dateRange, userData } from '@signals'


export default function useSearchAnalyticsDateRangeInfo() {
	const dateRangeSearches = useSignal(0)
	const userSiteTableData = useSignal([])
	const dateUserTableData = useSignal({})
	const pieChartData = useSignal({})
	const isDateRangeLoading = useSignal(false)

	const getDateRangeInfo = useCallback(() => {
		isDateRangeLoading.value = true
		postSubmit(`${BACKEND_APIS.SEARCH_ANALYTICS}/date-range`, {
			user: userData.value.username,
			uid: companyUsers.value,
			startBookingDate: formatDate(dateRange.value[0], { format: 'yyyy-MM-dd' }),
			endBookingDate: formatDate(dateRange.value[1], { format: 'yyyy-MM-dd' })
		}).then(data => batch(() => {
			const { bookingDateUser, bookingDateUserSorted, percentageSite, searches, siteSeries, userSite } = data
			dateRangeSearches.value = searches
			pieChartData.value = { percentageSite: percentageSite, siteSeries: siteSeries }
			userSiteTableData.value = userSite
			dateUserTableData.value = {
				bookingDateUserSorted: bookingDateUserSorted,
				bookingDateUser: bookingDateUser
			}
			isDateRangeLoading.value = false
		})).catch(() => {
			isDateRangeLoading.value = false
		})
	}, [JSON.stringify(companyUsers.value)])

	useEffect(() => {
		getDateRangeInfo()
	}, [JSON.stringify(companyUsers.value), JSON.stringify(dateRange.value)])


	return {
		dateRangeSearches: dateRangeSearches.value,
		isDateRangeLoading: isDateRangeLoading.value,
		userSiteTableData: userSiteTableData.value,
		dateUserTableData: dateUserTableData.value,
		pieChartData: pieChartData.value
	}
}